import { Component, OnInit } from '@angular/core';
import { UserService } from '../../../shared/user.service';
import { ClientDetailInstance } from '../client-detail.instance';
import { User } from '../../../models/user';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EditUserModalComponent } from '../../../users/shared/edit-user-modal/edit-user-modal.component';

@Component({
  selector: 'cw-client-detail-users',
  templateUrl: './client-detail-users.component.html',
  styleUrls: ['./client-detail-users.component.scss']
})
export class ClientDetailUsersComponent implements OnInit {
  users: User[];
  isLoading: boolean;

  constructor(private userService: UserService,
              private instance: ClientDetailInstance,
              private modal: NgbModal) {
    this.instance.$client.subscribe(client => {
      if (client) {
        this.loadUsers();
      }
    });
  }

  ngOnInit(): void {
  }

  onUserChange() {
    console.log('ok!');
    this.loadUsers();
  }

  showCreate() {
    const modalRef = this.modal.open(EditUserModalComponent);
    modalRef.componentInstance.initCreate(this.instance.client);
    modalRef.result.then(user => {
      this.loadUsers();
    });
  }

  private loadUsers() {
    this.userService.getForClient(this.instance.client).subscribe(users => {
      this.users = users;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/clients/client-detail/client-detail-users/client-detail-users.component.ts